"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UALHamianUser = exports.HamianResponse = void 0;
const universal_authenticator_library_1 = require("universal-authenticator-library");
const UALHamianError_1 = require("./UALHamianError");
class HamianResponse {
    constructor(data = null) {
        this.wasBroadcast = false;
        if (data) {
            Object.assign(this, data);
        }
    }
}
exports.HamianResponse = HamianResponse;
class UALHamianUser extends universal_authenticator_library_1.User {
    constructor(profile, hamian) {
        super();
        this.profile = profile;
        this.hamian = hamian;
    }
    signTransaction(transaction, config) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('transaction', transaction);
            console.log('transaction', config);
            var data = yield this.hamian.runTransaction(this.profile.wallet[0].wallet, transaction);
            console.log('responseData', data);
            if (data.response && data.response.data.response) {
                if (data.response.data.response.data) {
                    var transactionData = data.response.data.response.data;
                    var transactionResponse = new HamianResponse();
                    transactionResponse.transactionId = transactionData.transaction_id;
                    transactionResponse.transaction = transactionData.processed;
                    return transactionResponse;
                }
                else {
                    return new HamianResponse({ error: data.response.data.response.message });
                }
            }
            else {
            }
            return new HamianResponse({ error: '' });
            // throw new Error('Method not implemented.');
        });
    }
    signArbitrary(publicKey, data, helpText) {
        console.log('transaction', helpText);
        throw new UALHamianError_1.UALHamianError(`Hamian does not currently support signArbitrary(${publicKey}, ${data})`, universal_authenticator_library_1.UALErrorType.Unsupported, null);
    }
    verifyKeyOwnership(challenge) {
        throw new UALHamianError_1.UALHamianError(`Hamian does not currently support signArbitrary(${challenge} )`, universal_authenticator_library_1.UALErrorType.Unsupported, null);
    }
    getAccountName() {
        var wallet = this.profile.wallet[0];
        return wallet.value;
    }
    getChainId() {
        var wallet = this.profile.wallet[0];
        return wallet.wallet;
    }
    getKeys() {
        throw new Error('Method not implemented.');
    }
}
exports.UALHamianUser = UALHamianUser;
